"use strict";

module.exports = {
  'name': 'cot',
  'category': 'Trigonometry',
  'syntax': ['cot(x)'],
  'description': 'Compute the cotangent of x in radians. Defined as 1/tan(x)',
  'examples': ['cot(2)', '1 / tan(2)'],
  'seealso': ['sec', 'csc', 'tan']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/cot.js
// module id = 968
// module chunks = 0